"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXCONNECTOR_JWT_TTL = exports.OKXCONNECTOR_JWT_SIDE = void 0;
exports.OKXCONNECTOR_JWT_SIDE = "wallet";
exports.OKXCONNECTOR_JWT_TTL = 86400000;
